<template>
  <div class="rsvp-report-box">
    <div class="rsvp-report">
      <div class="form-group">
        <div class="instruction">Please select a start and end date:</div>
        <div class="row expanded">
          <div class="small-12 column">
            <select v-model="selectedWeek" class="weekly-select">
              <option v-for="(week, index) in weeks" :value="week" :key="index">
                {{ week.start.format('MMM DD') }} - {{ week.end.format('MMM DD') }}
              </option>
            </select>
          </div>
          <!-- <div class="small-6 column padding-R">
            <div class="date-input">
              <label>Start Date:</label>
              <datepicker class="datepicker" v-model="from" format="MMMM dd, yyyy" :highlighted="highlightedDates"></datepicker>
            </div>
          </div>
          <div class="small-6 column padding-L">
            <div class="date-input">
              <label>End Date:</label>
              <datepicker class="datepicker" v-model="to" format="MMMM dd, yyyy" :highlighted="highlightedDates"></datepicker>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="list-box">
      <div class="rsvp-report">
        <div class="form-group">
          <div class="download-type">
            <label :class="{'pdf':true, 'has-error':formatError}">
              <input type="checkbox" name="downloadType" v-model="pdfChecked"
                @click="formatCheck" />
              PDF
            </label>
            <label :class="{'csv':true, 'has-error':formatError}">
              <input type="checkbox" name="downloadType" v-model="csvChecked"
                @click="formatCheck" />
              CSV
            </label>
          </div>
          <div class="instruction">Please select the reports to generate:</div>
          <div class="row expanded reports">
            <div :class="['small-12 column report', reportStatus.payout, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.payout" />
                <span>{{ reportLabel('payout') }}</span>
              </label>
            </div>
          </div>
        </div>

        <transition name="slide-down">
          <div class="error" v-show="error.show">
            <span v-show="!!error.message">{{ error.message }}</span>
            <ul v-show="error.empty.length">
              <li>Empty Result:</li>
              <li v-for="empty in error.empty">- {{ empty }}</li>
            </ul>
          </div>
        </transition>
        <a v-bind:class="{ 'button cta success small block': true, disabled: pdf.loading }"
          href="javascript:;" @click="startProcess">
          <i class="fa fa-spinner fa-spin" v-show="pdf.loading"></i>
          <span v-show="!pdf.loading">Generate and Download Report</span>
        </a>
      </div>

      <div id="pdf-view" :class="[pdf.class]">
        <div v-for="(pageData, pageIndex) in pdf.table.data" :class="['page', pageIndex]" :key="pageIndex">
          <div class="title">{{ pdf.title }}</div>
          <div class="date-range">{{ pdf.date }}</div>
          <table>
            <thead>
              <tr>
                <th v-for="label in pdf.table.label" v-html="label"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in pageData" :key="index">
                <td v-for="(value, i) in data" :class="[i]" :key="i">{{ value }}</td>
              </tr>
              <tr v-if="isPayout && currentPage(pageIndex) == totalPage" class="total">
                <td>Total ({{ pdf.table.total.record }})</td>
                <td class="driverCount">{{ pdf.table.total.drivers }}</td>
                <td class="rsvpCount">{{ pdf.table.total.rsvp }}</td>
                <!-- <td class="totalPax">{{ pdf.table.total.pax }}</td>
                <td class="avgPax">{{ pdf.table.total.avgPax }}</td> -->
                <td class="fare">${{ pdf.table.total.fare }}</td>
                <td class="travelInsurance">${{ pdf.table.total.travelInsurance }}</td>
                <td class="airportFee">${{ pdf.table.total.airportFee }}</td>
                <td class="totalFare">${{ pdf.table.total.fareSum }}</td>
                <td class="avgFare">{{ pdf.table.total.avgFare }}</td>
                <td class="payment">${{ pdf.table.total.payment }}</td>
                <td class="paymentPercent">{{ pdf.table.total.paymentPercent }}%</td>
                <td class="pickupFee">${{ pdf.table.total.pickupFee }}</td>
                <td class="gasFee">${{ pdf.table.total.gasFee }}</td>
                <td class="tips">${{ pdf.table.total.tips }}</td>
                <td class="bonus">${{ pdf.table.total.bonus }}</td>
                <td class="cancelFee">${{ pdf.table.total.cancelFee }}</td>
                <td class="driverPayment">${{ pdf.table.total.extraFee }}</td>
                <td class="driverPercent">{{ pdf.table.total.percent }}%</td>
              </tr>
            </tbody>
          </table>
          <div class="page-count">page {{ currentPage(pageIndex) }} of {{ totalPage }}</div>
        </div>

        <div :class="['page', `page${Object.keys(pdf.table.data).length + 1}`]" v-if="Object.keys(pdf.table.data).length">
          <div class="title">{{ pdf.title }}</div>
          <div class="date-range">{{ pdf.date }}</div>
          <table>
            <thead>
              <tr>
                <th v-for="label in pdf.table.label" v-html="label"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in pdf.table.data[`page${Object.keys(pdf.table.data).length}`]" :key="index">
                <td v-for="(value, i) in data" :class="[i]" :key="i">{{ value }}</td>
              </tr>
              <tr v-if="isPayout" class="total">
                <td>Total ({{ pdf.table.total.record }})</td>
                <td class="driverCount">{{ pdf.table.total.drivers }}</td>
                <td class="rsvpCount">{{ pdf.table.total.rsvp }}</td>
                <td class="fare">${{ pdf.table.total.fare }}</td>
                <td class="travelInsurance">${{ pdf.table.total.travelInsurance }}</td>
                <td class="airportFee">${{ pdf.table.total.airportFee }}</td>
                <td class="totalFare">${{ pdf.table.total.fareSum }}</td>
                <td class="avgFare">{{ pdf.table.total.avgFare }}</td>
                <td class="payment">${{ pdf.table.total.payment }}</td>
                <td class="paymentPercent">{{ pdf.table.total.paymentPercent }}%</td>
                <td class="pickupFee">${{ pdf.table.total.pickupFee }}</td>
                <td class="gasFee">${{ pdf.table.total.gasFee }}</td>
                <td class="tips">${{ pdf.table.total.tips }}</td>
                <td class="bonus">${{ pdf.table.total.bonus }}</td>
                <td class="cancelFee">${{ pdf.table.total.cancelFee }}</td>
                <td class="driverPayment">${{ pdf.table.total.extraFee }}</td>
                <td class="driverPercent">{{ pdf.table.total.percent }}%</td>
              </tr>
            </tbody>
          </table>
          <div class="page-count">page {{ Object.keys(pdf.table.data).length }} of {{ totalPage }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import datepicker from 'vuejs-datepicker'
import CsvExport from 'csvexport'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'specialize-report',
  components: { datepicker },
  data () {
    return {
      from: null,
      to: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        payout: true
      },
      reportStatus: {
        payout: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      orientation: ['payout', 'cancellationReport', 'driverPaymentBonus', 'mileage'],
      pdfChecked: true,
      csvChecked: false,
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {}
      },
      searchAdmin: '',
      searchAdminId: '',
      searchAdminDelay: '',
      showSearchAdminList: false,
      weeks: [],
      selectedWeek: '',
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g)
    }
  },
  computed: {
    show () { return this.$store.state.reports.rsvpReport.show },
    highlightedDates () {
      let self = this
      let result = { to: null, from: null }
      if (self.from !== null) { result.from = self.from }
      if (self.to !== null) { result.to = self.to }
      return result
    },
    totalPage () { return Object.keys(this.pdf.table.data).length },
    isPayout () { return this.pdf.code === 'payout' && this.totalPage },
    admins () { return this.$store.state.reservationNotes.admins.filter(x => x.name.toLowerCase().includes(this.searchAdmin.toLowerCase())) },
  },
  methods: {
    isValid () {
      let self = this
      self.error.show = false
      self.error.empty = []
      // if (self.from === null || self.to === null) {
      //   self.error.show = true
      //   self.error.message = 'Please specify the Start and End dates.'
      //   return false
      // }
      let from = self.selectedWeek.start
      let to = self.selectedWeek.end
      if (from.isAfter(to)) {
        self.error.show = true
        self.error.message = 'End date must be after Start date.'
        return false
      }
      self.formatError = false
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true
        self.error.message = 'Please select which file format.'
        self.formatError = true
        return false
      }
      if (!self.selectedReports.payout) {
        self.error.show = true
        self.error.message = 'Please select at least one report type.'
        return false
      }
      return true;
    },
    getNewDoc () {
      let doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      })
      doc.setFont('helvetica')
      return doc
    },
    startProcess () {
      if (!this.isValid()) { return }
      this.pdf.list = []
      this.csv.list = []
      for (let report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue'
          this.pdf.list.push(report)
          this.csv.list.push(report)
        }
      }
      this.pdf.loading = true
      this.generateReport()
    },
    generateReport (isCsv = false) {
      if (((!this.pdf.list.length && this.pdfChecked) || !this.pdfChecked) &&
        ((!this.csv.list.length && this.csvChecked) || !this.csvChecked)
      ) {
        this.pdf.loading = false
        return
      }
      if (isCsv) {
        console.log('Processing:', this.csv.list[0])
        this.getDataReports(this.csv.list[0])
      } else {
        console.log('Processing:', this.pdf.list[0])
        this.getDataReports(this.pdf.list[0])
      }
    },
    getDataReports (type) {
      let self = this
      self.reportStatus[type] = 'loading'
      let orientationMax = self.orientation
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 25 : 40
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, r => {
        // console.log('---', r)
        // return
        if (r.error) {
          self.reportStatus[type] = 'has-error'
          return
        }
        self.setPdfLabel(type)
        self.pdf.table.data = {}
        self.pdf.table.extra = {}
        self.pdf.table.total = {}
        self.csv.data = []
        self.csv.total = {}
        if (r.list.length > 0) {
          self.buildPdfData(type, r.list)
        } else {
          self.error.show = true
          self.error.empty.push(self.reportLabel(type))
          self.reportStatus[type] = 'has-error'
          self.pdf.list.shift()
          self.csv.list.shift()
          self.generateReport()
        }
      })
    },
    apiParams (type) {
      let url = ''
      let start = this.selectedWeek.start
      let end = this.selectedWeek.end
      let data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      }
      switch (type) {
        case 'payout':
          url = '/reports/payout'
          break
      }
      return { url: url, data: data }
    },
    setPdfLabel (type) {
      let start = this.selectedWeek.start
      let end = this.selectedWeek.end
      let dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY')
      this.pdf.code = type
      if (type === 'payout') {
        this.pdf.class = 'report-payout'
        this.pdf.title = 'Opoli Reports - Payout'
        this.pdf.date = 'Driver Payouts and Fees for ' + dateRange
        // let riderFeeLabel = this.$settings.get('TravelInsuranceLabel') || 'Rider Fee'
        let riderFeeLabel = 'Service Fee'
        riderFeeLabel = riderFeeLabel.replace(' ', ' <br/>')
        this.pdf.table.label = [
          'Company', 'Provider <br/>ID', 'RSVP <br/>Count',
          //'Total <br/>PAX', 'Avg <br/>PAX', 
          'Fare', riderFeeLabel, 'Airport <br/>Fee', 'Total <br/>Fare', 'Avg <br/>Fare',
          // 'Average <br/>Fare PP', 'Charged',
          'Driver <br/>Payment', 'Payment %', 'Pickup <br/>Fee', 'Fuel <br/>Surcharge',
          'Tips', 'Bonus', 'Cancel <br/>Fee', 'Total <br/>Payout', 'Payout %'
        ]
      }
    },
    buildPdfData (type, pdfData) {
      let self = this
      let groupCount = 0
      let page = 1
      // payout
      let totalDrivers = 0
      let totalRsvp = 0
      let totalPickupFee = 0
      let totalTips = 0
      let totalBonus = 0
      let totalCancelFee = 0
      let totalGasFee = 0
      // let totalPax = 0
      // let totalAvgPax = 0
      let totalFare = 0
      let totalFareSum = 0
      let totalAvgFare = 0
      let totalTravelInsurance = 0
      let totalAirportFee = 0
      let totalPayment = 0
      let totalBidAmount = 0
      let totalPaymentPercentage = 0
      let totalAvgFarePP = 0
      let totalDriverPaymentOld = 0
      let totalDriverPayment = 0
      let totalDriverPercentage = 0
      pdfData.forEach(function (data, index) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = []
        }
        self.pdf.table.data['page' + page].push(self.buildTableData(type, data))
        if (self.csvChecked) {
          self.csv.data.push(self.buildCsvData(type, data))
        }
        groupCount++
        if (type === 'payout') {
          totalDrivers += data.drivers
          totalRsvp += data.rsvp
          totalGasFee += data.gasFee
          // totalPax += data.paxSum
          // totalAvgPax += parseFloat(data.paxAvg)
          totalFare += data.bidAmount
          totalTravelInsurance += parseFloat(data.travelInsurance || 0)
          totalAirportFee += parseFloat(data.airportFee || 0)
          totalFareSum += data.fareSum
          totalAvgFare += parseFloat(data.fareAvg)
          totalDriverPaymentOld += parseFloat((data.payment + data.bonus + data.pickupFee + data.tips) - data.cancelFee)

          totalDriverPayment += data.payoutStatus ? parseFloat(data.finalPayout) : data.total
          totalDriverPayment += data.gasFee

          totalPayment += data.payment
          totalBidAmount += data.bidAmount
          totalPickupFee += data.pickupFee
          totalTips += data.tips
          totalBonus += data.bonus
          totalCancelFee += data.cancelFee
          totalPaymentPercentage += parseFloat(data.paymentPercent || 0)
          totalDriverPercentage += parseFloat(data.percent)
        }
        if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) { page++ }
      })
      self.pdf.table.total.record = pdfData.length
      if (type === 'payout') {
        self.pdf.table.total.drivers = self.covertNumber(totalDrivers)
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp)
        // self.pdf.table.total.charged = self.covertNumber(totalCharged.toFixed(2))
        self.pdf.table.total.pickupFee = self.covertNumber(totalPickupFee.toFixed(2))
        self.pdf.table.total.tips = self.covertNumber(totalTips.toFixed(2))
        self.pdf.table.total.bonus = self.covertNumber(totalBonus.toFixed(2))
        self.pdf.table.total.cancelFee = self.covertNumber(totalCancelFee.toFixed(2))
        self.pdf.table.total.gasFee = self.covertNumber(totalGasFee.toFixed(2))
        // self.pdf.table.total.pax = self.covertNumber(totalPax)
        // self.pdf.table.total.avgPax = self.covertNumber((totalPax / totalRsvp).toFixed(2))
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2))
        self.pdf.table.total.travelInsurance = self.covertNumber(totalTravelInsurance.toFixed(2))
        self.pdf.table.total.airportFee = self.covertNumber(totalAirportFee.toFixed(2))
        self.pdf.table.total.fareSum = self.covertNumber(totalFareSum.toFixed(2))
        self.pdf.table.total.avgFare = self.covertNumber((totalFareSum / totalRsvp).toFixed(2))
        self.pdf.table.total.payment = self.covertNumber(totalPayment.toFixed(2))
        let paymentPercent = (totalPayment / totalFareSum) * 100
        self.pdf.table.total.paymentPercent = self.covertNumber(paymentPercent.toFixed(2))
        // self.pdf.table.total.avgFarePP = self.covertNumber(totalAvgFarePP.toFixed(2))
        let averagePercentage = totalDriverPercentage / pdfData.length
        self.pdf.table.total.extraFee = self.covertNumber(totalDriverPayment.toFixed(2))
        self.pdf.table.total.percent = self.covertNumber(((totalDriverPaymentOld / totalFareSum) * 100).toFixed(2))
      }
      if (self.pdfChecked) {
        self.processDownloads('pdf', {type: type, page: page})
      } else {
        self.processDownloads('csv', {type: type})
      }
    },
    buildTableData (type, data) {
      let self = this
      if (type === 'payout') {
        // let driverPayment = (data.payment + data.bonus + data.pickupFee + data.tips) - data.cancelFee
        let driverPayment = data.payoutStatus ? data.finalPayout : data.total
        driverPayment += data.gasFee
        return {
          company: data.name,
          driverCount: self.covertNumber(data.drivers),
          rsvpCount: self.covertNumber(data.rsvp),
          // totalPax: self.covertNumber(data.paxSum),
          // avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          fare: self.covertNumber(parseFloat(data.bidAmount).toFixed(2)),
          travelInsurance: self.covertNumber(parseFloat(data.travelInsurance || 0).toFixed(2)),
          airportFee: self.covertNumber(parseFloat(data.airportFee || 0).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          // avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2)),
          // charged: self.covertNumber(parseFloat(data.charged).toFixed(2)),
          payment: self.covertNumber(parseFloat(data.payment).toFixed(2)),
          paymentPercent: self.covertNumber(parseFloat(data.paymentPercent || 0).toFixed(2)),
          pickupFee: self.covertNumber(parseFloat(data.pickupFee).toFixed(2)),
          gasFee: self.covertNumber(parseFloat(data.gasFee).toFixed(2)),
          tips: self.covertNumber(parseFloat(data.tips).toFixed(2)),
          bonus: self.covertNumber(parseFloat(data.bonus).toFixed(2)),
          cancelFee: self.covertNumber(parseFloat(data.cancelFee).toFixed(2)),
          driverPayment: self.covertNumber(parseFloat(driverPayment).toFixed(2)),
          driverPercent: self.covertNumber(parseFloat(data.paymentPercent || 0).toFixed(2))
        }
      }
    },
    fileName (type, format) {
      let timestamp = this.selectedWeek.start.format('YYYYMMDD') + '_' + this.selectedWeek.end.format('YYYYMMDD')
      switch (type) {
        case 'payout': return 'reportspayout_' + timestamp + '.' + format
      }
    },
    currentPage (page) { return page.substring(4) },
    processPdf (type, page) {
      let self = this
      let start = moment(self.from)
      let end = moment(self.to)
      let pageAsyncs  = []
      let landscapeReports = self.orientation
      let orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p'
      let pdf = new jsPDF({ orientation: orientation, unit: 'mm', format: 'a4' })

      window.scrollTo(500, 0)
      document.body.style.overflow = 'hidden'

      setTimeout(() => {
        if (self.isIOS) page = page + 1
        for (let i = 0; i < page; i++) {
          // self.pdf.current = 'page' + (i + 1)
          pageAsyncs.push(html2canvas(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(canvas => {
            let imgData = canvas.toDataURL('image/jpeg', 1.0)
            pdf.addImage(imgData, 'JPEG', 0, 0)
            if (i + 1 !== page) { pdf.addPage() }
          }).catch(e => {
            self.reportStatus[type] = 'has-error'
            self.pdf.list.shift()
            document.body.style.overflow = 'auto'
            self.processDownloads('csv', {type: type})
            console.warn(e)
          }))
        }
        Promise.all(pageAsyncs).then(() => {
          let timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD')
          pdf.save(self.fileName(type, 'pdf'))
          self.reportStatus[type] = 'success'
          self.pdf.list.shift()
          document.body.style.overflow = 'auto'
          self.processDownloads('csv', {type: type})
        })
      }, 500)
    },
    covertNumber (value) { return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") },
    resetSelectedStatus () {
      this.selectedReports = {
        payout: false
      }
    },
    resetReportStatus () {
      this.error.show = false
      this.error.empty = []
      this.reportStatus = {
        payout: ''
      }
    },
    reportLabel (type) {
      switch (type) {
        case 'payout': return 'Payout Report'
      }
    },
    buildCsvData (type, data) {
      let column = []
      this.pdf.table.label.forEach(function(i) {
        column.push(i.replace('<br/>', ''))
      })
      this.csv.label = column
      let csvData = {}
      let pdfData = this.buildTableData(type, data)
      let i = 0
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key]
        i++
      }
      return csvData
    },
    processDownloads (action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page)
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type)
      } else {
        this.generateReport()
      }
    },
    processCsv (type) {
      const exporter = CsvExport.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      })
      // add total
      this.csv.data.push(this.buildCsvTotal(type))
      exporter.downloadCsv(this.csv.data)
      this.reportStatus[type] = 'success'
      this.csv.list.shift()
      this.generateReport(true)
    },
    buildCsvTotal (type) {
      let csvData = {}
      let totalData = this.pdf.table.total
      if (type === 'payout') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')'
        csvData[this.csv.label[1]] = totalData.drivers
        csvData[this.csv.label[2]] = totalData.rsvp
        // csvData[this.csv.label[3]] = totalData.pax
        // csvData[this.csv.label[4]] = totalData.avgPax
        csvData[this.csv.label[3]] = totalData.fare
        csvData[this.csv.label[4]] = totalData.travelInsurance
        csvData[this.csv.label[5]] = totalData.airportFee
        csvData[this.csv.label[6]] = totalData.fareSum
        csvData[this.csv.label[7]] = totalData.avgFare
        csvData[this.csv.label[8]] = totalData.payment
        csvData[this.csv.label[9]] = totalData.paymentPercent
        csvData[this.csv.label[10]] = totalData.pickupFee
        csvData[this.csv.label[11]] = totalData.gasFee
        csvData[this.csv.label[12]] = totalData.tips
        csvData[this.csv.label[13]] = totalData.bonus
        csvData[this.csv.label[14]] = totalData.cancelFee
        csvData[this.csv.label[15]] = totalData.extraFee
        csvData[this.csv.label[16]] = totalData.percent
      }
      if (type === 'cancellationReport') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')'
        csvData[this.csv.label[1]] = ''
        csvData[this.csv.label[2]] = ''
        csvData[this.csv.label[3]] = ''
        csvData[this.csv.label[4]] = totalData.fare
        csvData[this.csv.label[5]] = ''
        csvData[this.csv.label[6]] = ''
        csvData[this.csv.label[7]] = ''
        csvData[this.csv.label[8]] = ''
      }
      if (type === 'driverPaymentBonus') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')'
        csvData[this.csv.label[1]] = ''
        csvData[this.csv.label[2]] = ''
        csvData[this.csv.label[3]] = ''
        csvData[this.csv.label[4]] = totalData.baseFare
        csvData[this.csv.label[5]] = totalData.driverPayment
        csvData[this.csv.label[6]] = totalData.bonus
        csvData[this.csv.label[7]] = totalData.avgBonus
        csvData[this.csv.label[8]] = totalData.totalDriverPayment
        csvData[this.csv.label[9]] = ''
        csvData[this.csv.label[10]] = ''
      }
      if (type === 'mileage') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')'
        csvData[this.csv.label[1]] = ''
        csvData[this.csv.label[2]] = ''
        csvData[this.csv.label[3]] = ''
        csvData[this.csv.label[4]] = ''
        csvData[this.csv.label[5]] = totalData.rsvp
        csvData[this.csv.label[6]] = totalData.mileage
        csvData[this.csv.label[7]] = ''
      }
      return csvData
    },
    formatCheck () {
      this.error.show = false
      this.formatError = false
    },
    selectAdmin (admin) {
      this.searchAdmin = admin.name
      this.searchAdminId = admin.id
      this.showSearchAdminList = false
    },
    adminSearchFocus () {
      this.showSearchAdminList = true
      if (this.searchAdminDelay) {
        clearTimeout(this.searchAdminDelay)
      }
    },
    adminSearchBlur () {
      if (this.searchAdminDelay) {
        clearTimeout(this.searchAdminDelay)
      }
      this.searchAdminDelay = setTimeout(() => {
        this.showSearchAdminList = false
      }, 500)
    }
  },
  watch: {
    show (value) {
      if (!value) { return }
      this.from = null
      this.to = null
      this.error.show = false
      this.error.empty = []
      this.resetSelectedStatus()
      this.resetReportStatus()
    },
    from (value) { this.resetReportStatus() },
    to (value) { this.resetReportStatus() },
    'selectedReports.payout' (value) { this.resetReportStatus() },
  },
  mounted () {
    let self = this
    let start = moment().startOf('isoweek')
    let end = moment(start).endOf('isoweek')
    self.weeks = []
    self.weeks.push({
      start: start,
      end: end
    })
    self.selectedWeek = self.weeks[0]
    let current = moment(start).startOf('isoweek')
    for (let i = 0; i < 7; i++) {
      let startWeek = moment(current).subtract(1, 'd').startOf('isoweek')
      let endWeek = moment(startWeek).endOf('isoweek')
      current = moment(startWeek)
      self.weeks.push({
        start: startWeek,
        end: endWeek
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.rsvp-report-box {
  transform-origin: top center;
  position: relative;
  width: 100%;
}
.rsvp-report {
  border-radius: 3px;
  padding: 0 20px 20px;
  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 20px;
    font-size: 18px;
  }
  & .date-input {
    margin-bottom: 10px;
    & label {
      font-size: 13px;
      color: #999;
      display: block;
    }
    select{
      padding: 10px;
      height: 46px;
      outline: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border-color: #cacaca;
      font-size: 14px;
      color: #333;
      background-image: url('/assets/img/dropdown-arrow.png');
      background-repeat: no-repeat;
      background-position: right 50%;
      &[disabled]{ background-color: #ebebe4; }
    }
  }
  .reports{
    max-height: 350px;
    margin-bottom: 10px;
    overflow: auto;
    clear: both;
    background: #fafafa;
    border: 1px solid #ddd;
    position: relative;
    .report{
      position: relative;
      z-index: 1;
      &:hover{ background:#f1f1f1; }
      &.processing{
        background: rgba(0,0,0, .7);
        input{ opacity: .5; }
      }
      select{
        margin-left: 28px;
        margin-bottom: 10px;
        width: calc(100% - 43px);
        border-color: #999;
        font-size: 13px;
        color: #333;
        padding: 3px 5px;
        transition: all .2s ease;
        &.disabled{
          background: #fafafa;
          border-color: #ccc;
        }
        option:disabled{ background: #eaeaea; }
      }
      &.on-queue, &.loading, &.has-error, &.success{
        z-index: 3;
        box-shadow: 0 0 2px rgba(0,0,0, .4);
      }
      &.on-queue{ background: #fff; }
      &.loading{
        color: #775913;
        background: #f1ce7e;
      }
      &.success{
        color: #0f693a;
        background: #a9f7ce;
      }
      &.has-error{
        color: #b93030;
        background: #fbb0b0;
      }
    }
  }
}
.filter{
  list-style: none;
  margin: 0 0 5px;
  padding: 0;
  font-size: 13px;
  display: flex;
  li{
    margin: 2px 0;
    width: 100%;
  }
  label{ cursor: pointer;}
  input{
    display: inline-block;
    margin: 0 3px 0 0;
    width: auto;
    vertical-align: middle;
  }
}
.weekly-select{
  padding: 5px;
}
.download-type{
  float: right;
  width: 150px;
  text-align: right;
  padding-bottom: 5px;
  label{
    cursor: pointer;
    display: inline-block;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    padding: 2px 7px;
    border:1px solid #ddd;
    &.pdf{ color: #c54d4d; }
    &.csv{ color: #7ad275; }
    &.has-error{ border: 1px solid #d00; }
    input{
      display: inline;
      margin-top: 0;
      width: auto;
      vertical-align: -1px;
    }
  }
}
.list-box{
  overflow: hidden;
  position: relative;
  padding-bottom: 20px;
}
.error {
  background-color: #F25E0D;
  font-size: 14px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 15px;
  transform-origin: top center;
  ul{
    list-style: none;
    margin: 0;
    padding: 10px;
    text-align: left;
    li:first-child{
      font-weight: 600;
      font-size: 14px;
      line-height: 1;
      margin-bottom: 2px;
    }
    li{
      font-size: 13px;
    }
  }
}
.form-group {
  display: block;
  & .instruction {
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 600;
    color: #777;
  }
}
.checkbox {
  display: block;
  font-size: 13px;
  cursor: pointer;
  padding: 5px 10px;
  & > * {
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    width: auto;
  }
  input { margin-right: 3px; }
}
.padding-R { padding-right: 7px; }
.padding-L { padding-left: 7px; }
#pdf-view{
  position: absolute;
  top: 100%;
  left: 0;
  width: 793px;
  height: 1122px;
  background: #fff;
  .page{
    padding: 30px 40px 30px 30px;
    position: relative;
    width: 100%;
    height: 100%;
    .page-count{
      position: absolute;
      bottom: 10px;
      right: 30px;
      color: #aaa;
      font-size: 12px;
      text-align: right;
      font-style: italic;
    }
  }
  .title{
    text-align: center;
    font-weight: 600;
    font-size: 21px;
  }
  .date-range{
    text-align: center;
    font-style: italic;
    font-size: 18px;
    margin-bottom: 20px;
    color: #555;
  }
  table{
    width: 100%;
    font-size: 12px;
    border-collapse: collapse;
    thead{
      font-weight: 600;
      tr:last-child th{ border-bottom: 1px solid #333; }
    }
    tbody{
      tr{
        &.subtotal, &.total{ font-weight: 700; }
        &.total{
          color: #000;
          font-size: 12px;
        }
      }
      td{ padding: 2px 3px; }
    }
  }
}
.report-payout{
  width: 1122px!important;
  height: 793px!important;
  table{
    tbody tr.total{
      border-top: 1px solid #333;
      font-weight: 600;
      font-size:12.5px;
    }
    .driverCount, .rsvpCount, .totalPax, .avgPax{ text-align: center; }
    .gasFee, .fare, .totalFare, .avgFare, .travelInsurance, .airportFee, .extraFee, .charged, .payment, .pickupFee,
    .tips, .bonus, .cancelFee, .driverPayment, .paymentPercent, .driverPercent{ text-align: right; }
    .driverPayment{ font-weight: 600; }
    .gasFee, .fare, .travelInsurance, .airportFee, .payment, .pickupFee, .tips, .bonus, .cancelFee{ color: #777; }
    .company{
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
#pdf-view.mileage{
  width: 1122px!important;
  height: 793px!important;
  table{
    tbody tr.total{ border-top: 1px solid #333; }
    .date, .rsvpCount, .asap, .web, .admin, .app, .mileage{ text-align: center; }
    .totalFare, .avgFare, .extraFee, .driverPayment, .driverPercent{ text-align: right; }
    .driver, .service, .promo{
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .geofences{
      max-width: 110px;
      font-size: 11px;
    }
    .mileage{
      max-width: 70px;
    }
  }
}
.admin-box {
  position: relative;
  margin: 0 15px 15px 28px;
  input{
    padding: 5px 8px;
    margin: 0 0 5px;
    font-size: 14px;
  }
  ul{
    padding: 0;
    margin: 0;
    list-style: none;
    background: #fafafa;
    border: 1px solid #ccc;
    border-radius: 2px;
    height: 100px;
    overflow: auto;
    li{
      display: block;
      line-height: 1;
      padding: 5px 8px;
      font-size: 14px;
      color: #333;
      &:hover{
        background: #f3f3f3;
      }
    }
  }
}
.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Reports/DriverPayouts.vue